import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PaymentService, AuthService, ViewportService, ErrorHandlerService, ConfirmDialogModel, ConfirmDialogComponent } from 'epay-library';
import { IPaymentAccount } from 'epay-library/lib/features/common/models/payment/paymentaccount';


enum PrenoteStatus {
  Failed = '3',
  Prenote = '2',
  Active = '1',
}

@Component({
  selector: 'emp-payment-account',
  templateUrl: './emppayment-account.component.html'
})
export class EMPPaymentAccountComponent implements OnInit {
  @Input() baseurl = '';
  @Input() routingHelpImage = '';

  prenoteEnum = PrenoteStatus;

  isLoggedIn = false;
  isMobile = false;
  isLoadingAccounts = false;
  showAddEditPaymentAccount = false;

  paymentaccounts: IPaymentAccount[];
  accountForEdit: IPaymentAccount = {} as IPaymentAccount;
  usernumber: number;
  selectedAccountKey = '';
  errorMessage = '';
  message = '';
  deleteresult = '';

  confirmationSender = '';
  confirmationTitle = '';
  confirmationMessage = '';
  confirmationNumber = '';
  goToPrimary = '';
  goToPrimaryUrl = '';
  goToSecondary = '';
  goToSecondaryUrl = '';

  openConfirmation = false;

  constructor(
    private paymentService: PaymentService,
    private authservice: AuthService,
    private viewportService: ViewportService,
    private datePipe: DatePipe,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    public dialog: MatDialog,
    public snackbar: MatSnackBar
  ) {
    this.paymentaccounts = [];
    this.usernumber = 0;
    this.message = '';
    this.deleteresult = '';
  }

  ngOnInit() {
    this.authservice.isLoggedIn
      .subscribe((status) => (this.isLoggedIn = status))
      .unsubscribe();
    if (this.isLoggedIn) {
      this.isLoadingAccounts = true;
      this.getPaymentAccounts();
      this.isLoadingAccounts = false;
    }

    this.viewportService.IsMobile.subscribe(
      (mobile) => (this.isMobile = mobile)
    );
  }

  getPaymentAccounts() {
    this.paymentService.getPaymentAccounts(this.baseurl).subscribe({
      next: (accounts: any) => {
        this.paymentaccounts = this.filterOldAccount(accounts);
        if (this.paymentaccounts.length === 0) {
          this.accountForEdit = {} as IPaymentAccount;
          this.showAddEditPaymentAccount = true;
        }
      },
      error: (error: any) => {
        this.logError(error);
        this.handleError(error.status);
      },
    });
  }

  filterOldAccount(accounts: IPaymentAccount[]) {
    return accounts.filter(
      (account) =>
        this.datePipe.transform(account.inactiveDate, 'yyyy-MM-dd') ===
        '9999-12-31'
    );
  }

  editaccount(account: IPaymentAccount) {
    this.accountForEdit = account;
    if (!this.showAddEditPaymentAccount) {
      this.showAddEditPaymentAccount = true;
    }
  }

  addNewPaymentAccount() {
    this.accountForEdit = {} as IPaymentAccount;
    if (!this.showAddEditPaymentAccount) {
      this.showAddEditPaymentAccount = true;
    }
  }

  togglePaymentAccountPanel(result: any) {
    this.showAddEditPaymentAccount = result.show;
    if (result.success) {
      this.confirmationSender = 'Bank Account List';
      this.confirmationTitle = 'Success';
      this.confirmationMessage = result.message;
      this.confirmationNumber = result.confirmationNumber;
      this.goToPrimaryUrl = 'employer/achd/landing';
      this.goToPrimary = 'ACH Debit Home';
      this.goToSecondaryUrl = 'employer/achd/payment';
      this.goToSecondary = 'Schedule a Payment';
      this.openConfirmation = true;
    }
  }

  goToLanding() {
    this.router.navigateByUrl('employer/achd/landing');
  }

  goToPayments(account: IPaymentAccount) {
    this.router.navigateByUrl('employer/achd/payment', { state: account });
  }

  deleteaccount(account: IPaymentAccount) {
    const message = `Deleting your bank account will also delete all scheduled payments associated with this account.
                      Are you sure you want to delete this account?`;
    const acctdetail = account.bankName + '  ' + account.accountNumberMasked;
    const dialogData = new ConfirmDialogModel(
      'Confirm Deleting Account',
      message,
      acctdetail,
      '',
      '',
      '',
      ''
    );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '600px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe({
      next: (dialogResult) => {
        this.deleteresult = dialogResult;
      },
      error: (error: any) => console.log(error),
      complete: () => {
        if (this.deleteresult) {
          this.paymentService.deleteAccount(this.baseurl, account).subscribe({
            next: (success: any) => {
              this.getPaymentAccounts();
              this.confirmationSender = 'Bank Account List';
              this.confirmationTitle = 'Success';
              this.confirmationMessage = `Changes to your bank account information have been processed.
                 The payment draft previously associated with your bank draft account is no longer valid.
                 You must enter a new payment schedule for a draft payment to continue.`;
              this.confirmationNumber = success.confirmationNumber;
              this.goToPrimaryUrl = 'employer/home';
              this.goToPrimary = 'Home';
              this.openConfirmation = true;
            },
            error: (error: any) => {
              this.logError(error);
              this.handleError(error.status);
            },
          });
        }
      },
    });
  }

  openSnackBar(message: string, time: number, style: string) {
    const config = new MatSnackBarConfig();
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = time;
    config.panelClass = style;
    this.snackbar.open(message, '', config);
  }

  hideConfirmationPage(result: any) {
    this.getPaymentAccounts();
    this.openConfirmation = !result.hideConfirmation;
  }

  logError(error: Error) {
    this.errorHandlerService.logError(error);
  }

  handleError(error: number) {
    console.log('error', error);
    this.errorHandlerService.handleErrorMessage(error, this.baseurl);
  }
}

